import React from "react";
import "react-responsive-carousel/lib/styles/carousel.css"; // requires a loader
import { useHistory } from "react-router-dom";
import { SlideCarousel } from "./components";

import activeOrderCreation from "../../../../../assets/images/active-order-create.png";
import optionsIntegrations from "../../../../../assets/images/integration/optionsIntegrations.png";

import abbiamo10 from "../../../../../assets/images/abbiamo/abbiamo10.png";
import abbiamo11 from "../../../../../assets/images/abbiamo/abbiamo11.png";
import abbiamo12 from "../../../../../assets/images/abbiamo/abbiamo12.png";
import abbiamo13 from "../../../../../assets/images/abbiamo/abbiamo13.png";
import abbiamo14 from "../../../../../assets/images/abbiamo/abbiamo14.png";
import abbiamo15 from "../../../../../assets/images/abbiamo/abbiamo15.png";
import abbiamo16 from "../../../../../assets/images/abbiamo/abbiamo16.png";
import abbiamo2 from "../../../../../assets/images/abbiamo/abbiamo2.png";
import abbiamo3 from "../../../../../assets/images/abbiamo/abbiamo3.png";
import abbiamo4 from "../../../../../assets/images/abbiamo/abbiamo4.png";
import abbiamo5 from "../../../../../assets/images/abbiamo/abbiamo5.png";
import abbiamo8 from "../../../../../assets/images/abbiamo/abbiamo8.png";
import abbiamo9 from "../../../../../assets/images/abbiamo/abbiamo9.png";
import abbiamoCard from "../../../../../assets/images/abbiamo/abbiamoCard.png";

import styles from "./styles.module.scss";

const TutorialAbbiamo = () => {
  const baseUrl = `${process.env.REACT_APP_API_HOST}/abbiamo/webhook/order/create`;
  const history = useHistory();

  const steps1th = [
    { image: abbiamo12 },
    { image: abbiamo14 },
    { image: abbiamo15 },
  ];

  const steps2th = [
    { image: abbiamo4 },
    { image: abbiamo5 },
  ];

  const steps3th = [
    { image: abbiamo2 },
    { image: abbiamo3 },
  ];

  const steps4th = [
    { image: abbiamo8 },
    { image: abbiamo9 },
    { image: abbiamo16 },
    { image: optionsIntegrations },
    { image: abbiamoCard },
    { image: abbiamo10 },
    { image: abbiamo12 },
    { image: abbiamo13 },
    { image: abbiamo11 },
  ];

  return (
    <main className={styles.container}>
      <div className={styles.content}>
        <header className={styles.contentHeader}>
          <p>Como fazer a integração?</p>
        </header>
        <div className={styles.contentBody}>
          <section className={styles.contentSection}>
            <h4>
              Passo a passo para conectar sua plataforma Abbiamo à BRCom
            </h4>

            <div className={styles.bulletpoint}>
              <span>1</span>
              <p>
                Primeiro entre em contato com a Abbiamo para inserir a BRComerce no perfil do embarcador.
              </p>
            </div>

            <div className={styles.bulletpoint}>
              <span>2</span>
              <p>No dashboard da Abbiamo crie um novo Webhook
                <br></br> Evento: <b>ORDER_STATUS_CHANGE</b>
                <br></br> Webhook URL: <b>{baseUrl}</b>
              </p>
            </div>

            <SlideCarousel steps={steps1th} />

            <div className={styles.bulletpoint}>
              <span>3</span>
              <p>
                Em seguida copie o Identificador da filial e Token da API e cole nas configurações da BRCom
              </p>
            </div>

            <SlideCarousel steps={steps4th} />


            <div className={styles.bulletpoint}>
              <span>4</span>
              <p>
                Configure os dados do remetente, se deseja seguro.
                <br></br>
                O frete customizado serve para importar pedidos que não foram cotados previamente pela BRCom.
                <br></br>
                Essas configurações serão aplicadas em todos os pedidos importados pela BRCom.
              </p>
            </div>

            <SlideCarousel steps={steps2th} />

            <div className={styles.bulletpoint}>
              <span>5</span>
              <p>
                Pronto, agora é só <b>Salvar</b> a integração. <br />
              </p>
            </div>

            <div className={styles.bulletpoint}>
              <span>6</span>
              <p>
                Para importar os pedidos é só solicitar a coleta para os pedidos da filial informada, selecionando nossas opções de frete.
              </p>
            </div>

            <SlideCarousel steps={steps3th} />

            <div className={styles.bulletpoint}>
              <span>7</span>
              <p>
                Caso queira desativar a criação de pedido nessa integração, vire a chave para "Desativado"
                <br></br>
                As demais funcionalidades relacionadas a essa integração continuarão ativas.
              </p>
            </div>

            <div className={styles.imgs}>
              <img
                src={activeOrderCreation}
                alt="activeOrderCreation"
                className={styles.cardImage}
              />
            </div>

            <button
              onClick={() => history.push("/integracoes")}
              className={`${styles.button} ${styles.btnBack}`}
            >
              Voltar
            </button>
          </section>
        </div>
      </div>
    </main>
  );
};

export { TutorialAbbiamo };
